<template>
  <header class="bg-pink-500 text-white px-4">
    <nav class="container main-nav mx-auto flex flex-wrap justify-start max-lg:py-3 py-8">
      <ul class="main-nav__mainmenue flex flex-wrap gap-20">
        <li>
          <NuxtLink to="/">Home</NuxtLink>
        </li>
<!--        <li>-->
<!--          <NuxtLink to="/blog">Blog</NuxtLink>-->
<!--        </li>-->
      </ul>
    </nav>
  </header>
  <slot />
  <footer class="px-4 main-footer container mx-auto flex flex-wrap justify-end py-8 sticky-bottom">
    <div class="main-nav__submenu-wrapper">
      <ul class="main-nav__submenu flex flex-row gap-x-5">
        <li v-for="item in imprint?.[0]?.children">
          <NuxtLink :to="item?.path" :key="item.path">{{ item?.path.split('/').pop()?.toUpperCase() }}</NuxtLink>
        </li>
      </ul>
    </div>
  </footer>
</template>

<script setup lang="ts">
const { data: imprint } = await useAsyncData('imprints', () => {
  return queryCollectionNavigation('imprints')
})
</script>

<style lang="scss" scoped>
</style>